
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/curated-shortlist/success",
      function () {
        return require("private-next-pages/curated-shortlist/success.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/curated-shortlist/success"])
      });
    }
  